import { InformationCircleIcon } from '@heroicons/react/24/outline';

import type { GroupSeatStatus } from '../groupSubscriptionTypes';
import { STATUS_STYLES } from './groupCard.utils';

const TERMINATING_TOOLTIP =
  'This member will lose access at renewal because your seat count is being reduced. They keep access until then.';

type SeatStatusBadgeProps = {
  status: GroupSeatStatus;
};

export function SeatStatusBadge({ status }: SeatStatusBadgeProps) {
  const style = STATUS_STYLES[status];
  // Terminating seats carry an info affordance — the label alone ("Ends at
  // renewal") doesn't explain *why* the member is losing access, and admins
  // who didn't schedule the reduction themselves need that context.
  const isTerminating = status === 'terminating';
  return (
    <span
      title={isTerminating ? TERMINATING_TOOLTIP : undefined}
      className={`inline-flex h-6 items-center gap-1 rounded border px-2 py-1 text-xs font-medium ${style.className}`}
    >
      {style.label}
      {isTerminating && <InformationCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />}
    </span>
  );
}
